/*
 *
 * DimensionByDivision reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_DIMENSIONS_SUCCESS,
  GET_DIMENSIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_WATCHER,
  GET_HISTORY_BY_DIVISION_FAILED,
  GET_HISTORY_BY_DIVISION_SUCCESS,
  GET_HISTORY_BY_DIVISION_WATCHER,
  GRAPHIC_BARS_FAILED,
  GRAPHIC_BARS_SUCCESS,
  GRAPHIC_BARS_WATCHER,
  GET_AMBASSADORS_WATCHER,
  GET_AMBASSADORS_SUCCESS,
  GET_AMBASSADORS_FAILED,
  GET_ONLY_DIMENSIONS_WATCHER,
  GET_ONLY_DIMENSIONS_SUCCESS,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_QUESTIONS_WATCHER,
  GET_QUESTIONS_SUCCESS,
  GET_QUESTIONS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  dimensions: [],
  outcomes: [],
  metricTotal: {},
  showHistory: false,
  showDimensionBenchmark: false,
  switchMoreDimensions: false,
  divisionsAvailable: [],
  measureInfo: {},
  ambassadorBenchmarkVisible: false,
  isEngagement: true,
  isEngagementOnly: false,
  evolutionData: [],
  evolutionLines: [],
  employeesTotal: 0,
  ifFirst: false,
  questionList: [],
})

function dimensionByDivisionReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ONLY_DIMENSIONS_SUCCESS:
      return state
        .set("isLoading", false)
        .set("dimensions", action.payload.dimensions)
        .set("measureInfo", action.payload.measureInfo)
        .set("showDimensionBenchmark", action.payload.showDimensionBenchmark)
        .set("isEngagement", action.payload.measureInfo.is_engagement)
        .set("employeesTotal", action.payload.employeesTotal)
        .set(
          "isEngagementOnly",
          action.payload.measureInfo.is_engagement &&
            !action.payload.measureInfo.has_enps
        )
    case GET_QUESTIONS_SUCCESS:
      return state.set("questionList", action.payload)

    case GET_AMBASSADORS_WATCHER:
      return state.set("ambassadors", []).set("isLoadingAmbassadors", true)

    case GET_AMBASSADORS_SUCCESS:
      return state
        .set("ambassadors", action.payload)
        .set("isLoadingAmbassadors", false)

    case GET_AMBASSADORS_FAILED:
      return state.set("ambassadors", []).set("isLoadingAmbassadors", false)

    case GRAPHIC_BARS_WATCHER:
      return state.set("graphicBars", []).set("isLoadingGraphicBars", true)

    case GRAPHIC_BARS_SUCCESS:
      return state
        .set("graphicBars", action.payload)
        .set("isLoadingGraphicBars", false)

    case GRAPHIC_BARS_FAILED:
      return state.set("graphicBars", []).set("isLoadingGraphicBars", false)

    case GET_DIVISIONS_WATCHER:
      return state.set("divisions", [])
    case GET_DIVISIONS_SUCCESS:
      return state
        .set("divisions", action.payload.data)
        .set("divisionsTotal", action.payload.total)
    case GET_DIMENSIONS_WATCHER:
      if (action.payload.onlyDimension) return state

      return state
        .set("isLoading", true)
        .set("dimensions", [])
        .set("metric_total", [])
        .set("outcomes", [])
        .set("show_history", false)
        .set("switchMoreDimensions", false)
        .set("employeesTotal", 0)
    case GET_DIMENSIONS_SUCCESS:
      return state
        .set("isLoading", false)
        .set("dimensions", action.payload.dimensions)
        .set("outcomes", action.payload.outcomes)
        .set("metricTotal", action.payload.metricTotal)
        .set("showHistory", action.payload.showHistory)
        .set("ifFirst", action.payload.ifFirst)
        .set("showDimensionBenchmark", action.payload.showDimensionBenchmark)
        .set("switchMoreDimensions", action.payload.switchMoreDimensions)
        .set("measureInfo", action.payload.measureInfo)
        .set("employeesTotal", action.payload.employeesTotal)
        .set(
          "ambassadorBenchmarkVisible",
          action.payload.ambassadorBenchmarkVisible
        )
        .set("isEngagement", action.payload.measureInfo.is_engagement)
        .set(
          "isEngagementOnly",
          action.payload.measureInfo.is_engagement &&
            !action.payload.measureInfo.has_enps
        )

    case GET_HISTORY_BY_DIVISION_WATCHER:
      return state.set("isLoadingGraphicPeakon", true)

    case GET_HISTORY_BY_DIVISION_SUCCESS:
      return state
        .set("evolutionData", action.payload.dataValues)
        .set("evolutionLines", action.payload.dataLines)
        .set("isLoadingGraphicPeakon", false)

    case GET_HISTORY_BY_DIVISION_FAILED:
      return state
        .set("isLoadingGraphicPeakon", false)
        .set("evolutionLines", [])
        .set("evolutionData", [])

    case GET_MEASURE_COLOR_RANGE_SUCCESS:
      return state.set("measureColorRange", action.payload.report_color_range)

    default:
      return state
  }
}

export default dimensionByDivisionReducer
